import type { NextPage } from 'next'
import BodyText from '../lib/components/body-text'
import PageHeader from '../lib/components/page-header'

const Login: NextPage = () => {
  return (
    <>
      <PageHeader title="Send feedback" />
      <div className="mt-4">
        <BodyText>I'd love to hear about what you're using the plugin for and what you're using it for!</BodyText>
        <BodyText>
          And if you're not finding it helpful or seeing issues, I'm especially keen to hear about how you think it can be improved or get examples of
          poor performance.{' '}
        </BodyText>{' '}
        <BodyText>
          Please get in touch directly:{' '}
          <a className="text-green-800 underline hover:text-green-600" href="mailto:me@davidhu.me">
            me@davidhu.me
          </a>
          .
        </BodyText>
      </div>
    </>
  )
}

export default Login
